import { apiClient } from "../apiClient";

const ENDPOINT = "email-nhap-hoc";

/**
 * Gửi lại email nhập học: máy chủ gọi ĐƯỜNG DẪN CALLBACK sang cổng nhập học, cổng đó mới
 * là nơi soạn và gửi email. Không liên quan email biên lai qua SMTP của phần mềm.
 */
export const emailNhapHocApi = {
  /** Bắn yêu cầu rồi trả ngay, KHÔNG chờ cổng nhập học phản hồi.
   *  Dùng cho cả tự động (sau khi ra biên lai) lẫn nút gửi lại. */
  Gui: (id_sv: string) => apiClient.post(`${ENDPOINT}/gui/${id_sv}`, {}),
};
